var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"atfActivityNews content_area clearfix"},[_c('div',{staticClass:"titleNews"},[_vm._v(_vm._s(_vm.$t("newsInformation")))]),(_vm.imgOption.imgList.length > 0)?_c('newSlider',{attrs:{"imgOption":_vm.imgOption,"autoPlay":true,"isViewClick":true},on:{"viewChange":_vm.handleClick}}):_c('noDataImg')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }